import {
  Button,
  CloseButton,
  Heading,
  Link,
  Modal,
  Spinner,
  Text,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { Files } from "../../../../services/FilesService";
import {
  ERROR,
  useNotification,
} from "../../../CustomHooks/NotificationProvider";
import EnrichedFileDrop from "../../../LearningOutcomes/FileDrop/EnrichedFileDrop";
import { enrichCLOs } from "../utils";

const LEARNING_OUTCOMES_FILE_TYPE = "learningOutcomes";

const CLOUploadModal = ({
  course,
  offering,
  uploadDialog,
  setUploadDialog,
  subject,
}) => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const [LOFile, setLOFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleSubmit = () => {
    if (LOFile) {
      setUploading(true);
      Files.saveFile(LOFile, LEARNING_OUTCOMES_FILE_TYPE)
        .then(() => {
          setUploadDialog(false);
          setLOFile(null);
          showNotification(t("learningOutcomes.uploadSuccess"));
        })
        .catch(() => showNotification(t("learningOutcomes.uploadError"), ERROR))
        .finally(() => setUploading(false));
    }
  };

  const handleCancel = () => {
    setUploadDialog(false);
    setLOFile(null);
  };

  return (
    <Modal open={uploadDialog} label={t("global.dragFile")}>
      <Modal.Header>
        <Heading level="h2" as="h1">
          {t("learningOutcomes.cloUploadFor", { offering: offering.code })}
        </Heading>
        <CloseButton
          placement="end"
          offset="medium"
          screenReaderLabel={t("global.close")}
          onClick={handleCancel}
        />
      </Modal.Header>
      <Modal.Body>
        <EnrichedFileDrop
          fileState={LOFile}
          setFileState={setLOFile}
          enriched_content={enrichCLOs(course.id, offering.id, subject)}
          fileDropHeading={t("clo.dropFileHeading")}
          fileExtension=".csv"
        />
        <div style={{ marginTop: 10 }}>
          <Text as="div">{t("learningOutcomes.predefinedStructure")}</Text>
          <br />
          <Text as="div">{t("clo.uploadLine2")}</Text>
          <br />
          <Text as="div">
            <Link href="/sampleCLOs.csv">
              {t("global.downloadExampleFile")}
            </Link>
          </Text>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button margin="0 small 0 0" onClick={handleCancel}>
          {t("global.cancel")}
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={!LOFile || uploading}
        >
          {uploading ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("global.submit")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CLOUploadModal;
